// src/components/Schedule.js
import { CAT_ICONS } from "../constants";

export default function Schedule({ tasks, onSelect }) {
 const scheduled = tasks
 .filter(t => t.dueDate && !t.completed)
 .sort((a, b) => new Date(a.dueDate) - new Date(b.dueDate));

 const recurring = tasks.filter(t => t.recurrence && t.recurrence !== "None");

 return (
 <div className="fade-in">
 <div style={styles.grid2}>
 {/* Scheduled */}
 <div className="card">
 <h3 style={styles.cardTitle}> Scheduled Tasks</h3>
 {scheduled.length === 0
 ? <EmptyState icon="" text="No scheduled tasks." />
 : scheduled.map(t => {
 const d = new Date(t.dueDate + "T12:00:00");
 const isOverdue = d < new Date();
 return (
 <div key={t.id} className="task-row" style={{ borderRadius: 10, background: isOverdue ? "#fff5f5" : "transparent" }}
 onClick={() => onSelect(t)}>
 <div style={{
 textAlign: "center", minWidth: 52, borderRadius: 10,
 padding: "6px 8px", color: "white", flexShrink: 0,
 background: isOverdue ? "#ef4444" : "#f97316",
 }}>
 <div style={{ fontFamily: "'Fredoka One', cursive", fontSize: 20, lineHeight: 1 }}>{d.getDate()}</div>
 <div style={{ fontSize: 10, fontWeight: 800, letterSpacing: "0.06em" }}>
 {d.toLocaleString("default", { month: "short" }).toUpperCase()}
 </div>
 </div>
 <div style={{ flex: 1 }}>
 <div style={{ fontWeight: 700, fontSize: 14 }}>{t.title}</div>
 <div style={{ fontSize: 12, color: "#a07850", fontWeight: 600 }}>
 {CAT_ICONS[t.category]} {t.category}{isOverdue ? " · Overdue!" : ""}
 </div>
 </div>
 </div>
 );
 })
 }
 </div>

 {/* Recurring */}
 <div className="card">
 <h3 style={styles.cardTitle}> Recurring Maintenance</h3>
 {recurring.length === 0
 ? <EmptyState icon="" text="No recurring tasks set up yet." />
 : recurring.map(t => (
 <div key={t.id} className="task-row" style={{ borderRadius: 10 }} onClick={() => onSelect(t)}>
 <span style={{ fontSize: 20 }}>{CAT_ICONS[t.category]}</span>
 <div style={{ flex: 1 }}>
 <div style={{ fontWeight: 700, fontSize: 14 }}>{t.title}</div>
 <div style={{ fontSize: 12, color: "#a07850", fontWeight: 600 }}>{t.category}</div>
 </div>
 <span style={{ background: "#f0fdf4", color: "#22c55e", padding: "3px 10px", borderRadius: 20, fontSize: 11, fontWeight: 800, textTransform: "uppercase" }}>
 ↻ {t.recurrence}
 </span>
 </div>
 ))
 }
 </div>
 </div>

 {/* Calendar hint */}
 <div className="card" style={{ marginTop: 20, background: "#fff7ed", border: "2px solid #fed7aa" }}>
 <h3 style={{ ...styles.cardTitle, color: "#c2410c", marginBottom: 8 }}> Maintenance Calendar Tips</h3>
 <div style={{ display: "grid", gridTemplateColumns: "repeat(3,1fr)", gap: 12 }}>
 {MAINTENANCE_TIPS.map((tip, i) => (
 <div key={i} style={{ background: "white", borderRadius: 12, padding: "14px", border: "1px solid #fed7aa" }}>
 <div style={{ fontSize: 24, marginBottom: 6 }}>{tip.icon}</div>
 <div style={{ fontWeight: 800, fontSize: 13, color: "#8B4513", marginBottom: 4 }}>{tip.title}</div>
 <div style={{ fontSize: 12, color: "#a07850", fontWeight: 600, lineHeight: 1.5 }}>{tip.text}</div>
 </div>
 ))}
 </div>
 </div>
 </div>
 );
}

function EmptyState({ icon, text }) {
 return (
 <div style={{ textAlign: "center", padding: 24, color: "#c09870" }}>
 <div style={{ fontSize: 36, marginBottom: 8 }}>{icon}</div>
 <p style={{ fontWeight: 700 }}>{text}</p>
 </div>
 );
}

const MAINTENANCE_TIPS = [
 { icon: "", title: "Spring (Mar–May)", text: "Inspect roof, clean gutters, service A/C, check exterior paint, test smoke detectors." },
 { icon: "", title: "Summer (Jun–Aug)", text: "Check sprinklers, inspect deck/patio, clean dryer vent, seal driveway cracks." },
 { icon: "", title: "Fall (Sep–Nov)", text: "Clean gutters, drain hoses, service furnace, caulk windows/doors, check weatherstripping." },
 { icon: "", title: "Winter (Dec–Feb)", text: "Insulate pipes, reverse ceiling fans, check for drafts, test carbon monoxide detectors." },
 { icon: "", title: "Monthly", text: "Replace HVAC filters, test GFCI outlets, check water heater, inspect fire extinguishers." },
 { icon: "", title: "Annually", text: "Professional HVAC tune-up, septic pump, chimney sweep, pest inspection, water heater flush." },
];

const styles = {
 grid2: { display: "grid", gridTemplateColumns: "1fr 1fr", gap: 20 },
 cardTitle: { fontFamily: "'Fredoka One', cursive", fontSize: 20, color: "#8B4513", marginBottom: 16 },
};
